import Repository from "./Repository";

const GET_REGULATIONS_POLICY = "getall";
const CREATE_REGULATIONS_POLICY = "Add";
const UPDATE_REGULATIONS_POLICY = "edit";
const DELETE_REGULATIONS_POLICY = "delete";

export default {
  createRegulations(payload) {
    return Repository.post(transformRoute(CREATE_REGULATIONS_POLICY), payload);
  },
  deleteRegulations(payload) {
    return Repository.post(transformRoute(DELETE_REGULATIONS_POLICY), payload);
  },
  getRegulations(payload) {
    return Repository.get(transformRoute(GET_REGULATIONS_POLICY), payload);
  },
  editRegulations(payload) {
    return Repository.post(transformRoute(UPDATE_REGULATIONS_POLICY), payload);
  },
};

const transformRoute = (route) => {
  return `/cms/regulations/${route}`;
};
